import clsx from 'clsx';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { DrawerProps, Icon, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { NavLink, useLocation } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { NavigatorData } from './NavigatorData';
import { DeltaXMLColors, MyDeltaColors} from './styling/DeltaColors';

const styles = (theme: Theme) =>
    createStyles({
        item: {
            paddingTop: 1,
            paddingBottom: 1,
            color: MyDeltaColors.WHITE,
            '&:hover': {
                backgroundColor: DeltaXMLColors.OXFORD_BLUE,
                color: DeltaXMLColors.CELERY,
            },
            '&:focus': {
                backgroundColor: DeltaXMLColors.OXFORD_BLUE,
                color: DeltaXMLColors.CELERY,
            }
        },
        itemActiveItem: {
            color: DeltaXMLColors.CELERY,
            backgroundColor: DeltaXMLColors.OXFORD_BLUE,
        },
        itemIcon: {
            minWidth: 'auto',
            marginRight: theme.spacing(2),
        },
        nested: {
            paddingLeft: theme.spacing(6),
        },
    });

function isActiveLink(path: string, href: string) {
    const hrefPart = href.substring(1);
    return path === ''? href === NavigatorData.baseUrl :  path === hrefPart;
}
export interface NavItemProps extends Omit<DrawerProps, 'classes'>, WithStyles<typeof styles> {
    id: string,
    icon: JSX.Element;
    link: string;
    hasListItems?: boolean;
    isOpen?: boolean;
    handleClick?: () => void;
    isNested?: boolean;
}

function NavItem(props: NavItemProps) {
    const { classes, id, icon, link, isOpen, hasListItems, handleClick, isNested} = props;
    const windowPath = useLocation();
    const path = windowPath.pathname.substring(windowPath.pathname.indexOf('/') + 1);

    return (
        <NavLink
            key={id}
            to={link}
            style={{ textDecoration: 'none' }}>
            <ListItem
                onClick={handleClick}
                key={id}
                button
                className={ (isNested === true) ? clsx(classes.item, classes.nested, isActiveLink(path, link) && classes.itemActiveItem) : clsx(classes.item, isActiveLink(path, link) && classes.itemActiveItem)}
            >
                <ListItemIcon className={classes.itemIcon}><Icon>{icon}</Icon></ListItemIcon>
                <ListItemText>
                    {id}
                </ListItemText>
                { (hasListItems === true) ? (isOpen ? <ExpandLess /> : <ExpandMore />) : null}               
            </ListItem>
        </NavLink>

    );
}

export default withStyles(styles)(NavItem);